import { gql } from '@provision/graphql-client';

export const WORKFLOW_FIELDS = gql`
  fragment WorkflowFields on Workflow {
    id
    workflowId
    partnerId
    name
    description
    createdAt
    updatedAt
  }
`;

export const WORKFLOW_VERSION_FIELDS = gql`
  fragment WorkflowVersionFields on WorkflowVersion {
    id
    workflowVersionId
    workflowId
    partnerId
    version
    isActive
    definition
    description
    createdAt
    updatedAt
    deletedAt
  }
`;

export const WORKFLOW_ASSIGNMENT_FIELDS = gql`
  fragment WorkflowAssignmentFields on WorkflowAssignment {
    id
    workflowAssignmentId
    partnerId
    workflowId
    workflowPartnerId
    triggerType
  }
`;
